import styled from "styled-components";
import { Alert } from "../../../alerts/Alert";
import { Heading } from "../../../Heading";
import { Device } from "../../../../styles/screenSizes";

export const StyledAlert = styled(Alert)`
  padding: 4px 8px;
`;

export const StyledCartItem = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 16px 0;
  width: 320px;

  @media ${Device.mobile} {
    width: 100%;
  }
`;

export const StyledDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
`;

export const StyledHeading = styled(Heading)`
  max-width: 165px;
  overflow-wrap: break-word;
`;

export const StyledTopDetails = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;
